module.exports = __webpack_public_path__ + "7e37ad03e98df27c17dea07de144d610.woff2";